export let yPos = 0;
export let pixelsPerScroll = 20;
export let scrollDirection = 0;

const IMAGE_ID = 'thirdparty_litmus_screenimg';
const CONTAINER_ID = 'thirdparty_litmus_mobile_container';
const DEFAULT_VIEWPORT_HEIGHT = 372;

function getViewportHeight() {
  const container = document.getElementById(CONTAINER_ID);
  return container?.offsetHeight ?? DEFAULT_VIEWPORT_HEIGHT;
}

function getImageElement() {
  return document.getElementById(IMAGE_ID);
}

export function resetYPos() {
  yPos = 0;
  const imgEl = getImageElement();
  if (imgEl) {
    imgEl.style.top = '0px';
  }
}

export function doScrollDown(pos) {
  const imgEl = getImageElement();
  if (!imgEl) return;
  const viewportHeight = getViewportHeight();
  // Guard: if image height fits within viewport, disable custom scroll
  if (imgEl.height <= viewportHeight) {
    yPos = 0;
    imgEl.style.top = '0px';
    scrollDirection = 0;
    return;
  }

  yPos -= pixelsPerScroll;
  if (yPos > 0) yPos = 0;
  pixelsPerScroll -= 1;

  const maxOffset = Math.max(imgEl.height - viewportHeight, 0);

  if (-yPos >= maxOffset) {
    const clamped = -maxOffset;
    imgEl.style.top = clamped + 'px';
    yPos = clamped;
    scrollDirection = 0;
    return;
  } else if (yPos <= 0) {
    imgEl.style.top = yPos + 'px';
  }

  if (yPos > pos) {
    if (pixelsPerScroll < 8) pixelsPerScroll = 2;
    setTimeout(() => doScrollDown(pos), 20);
  } else {
    scrollDirection = 0;
  }
}

export function doScrollUp(pos) {
  const imgEl = getImageElement();
  if (!imgEl) return;
  const viewportHeight = getViewportHeight();
  // Guard: if image height fits within viewport, disable custom scroll
  if (imgEl.height <= viewportHeight) {
    yPos = 0;
    imgEl.style.top = '0px';
    scrollDirection = 0;
    return;
  }

  yPos += pixelsPerScroll;
  pixelsPerScroll -= 1;

  const maxOffset = Math.max(imgEl.height - viewportHeight, 0);

  if (-yPos >= maxOffset) yPos = -maxOffset;

  if (yPos <= 0) {
    imgEl.style.top = yPos + 'px';
  } else {
    yPos = 0;
    imgEl.style.top = '0px';
    scrollDirection = 0;
    return;
  }

  if (yPos < pos) {
    if (pixelsPerScroll < 8) pixelsPerScroll = 2;
    setTimeout(() => doScrollUp(pos), 20);
  } else {
    scrollDirection = 0;
  }
}

export function doScrollDownBy(pixels) {
  if (scrollDirection === 0) {
    scrollDirection = -1;
    pixelsPerScroll = 20;
    doScrollDown(yPos - pixels);
  }
}

export function doScrollUpBy(pixels) {
  if (scrollDirection === 0) {
    scrollDirection = 1;
    pixelsPerScroll = 20;
    doScrollUp(yPos + pixels);
  }
}

export function scrollUp() {
  doScrollUpBy(200);
}

export function scrollDown() {
  doScrollDownBy(200);
}

export function onKeyDown(e) {
  if (!getImageElement()) return;

  switch (e.key) {
    case 'ArrowUp':
      e.preventDefault();
      scrollUp();
      break;
    case 'ArrowDown':
      e.preventDefault();
      scrollDown();
      break;
  }
}

document.onkeydown = onKeyDown;
